import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { ToolbarButton } from "../ToolbarButton";
const ToggleButton = ({
  Icon,
  label,
  onClick,
  dataHook,
  tooltip,
  active,
  disabled,
  setRef
}) => {
  const { isMobile } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setRef,
      isMobile,
      active,
      tooltip,
      disabled,
      onClick,
      Icon,
      label,
      dataHook
    }
  );
};
var ToggleButton_default = ToggleButton;
export {
  ToggleButton_default as default
};
//# sourceMappingURL=ToggleButton.js.map
